import { render } from "./NewRecipeButton.vue?vue&type=template&id=a1387886"
import script from "./NewRecipeButton.vue?vue&type=script&lang=js"
export * from "./NewRecipeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__